import { render, staticRenderFns } from "./YKDocuments.vue?vue&type=template&id=0c8d2e84&"
import script from "./YKDocuments.vue?vue&type=script&lang=js&"
export * from "./YKDocuments.vue?vue&type=script&lang=js&"
import style0 from "./YKDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports